export const FORGOT_RESET = 'FORGOT_RESET';
export const FORGOT_CODE = 'FORGOT_CODE';
export const FORGOT_SET_PASSWORD = 'FORGOT_SET_PASSWORD';
